import {
  FacebookLoginProvider,
  SocialAuthService,
  SocialUser,
} from '@abacritt/angularx-social-login';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, takeUntil } from 'rxjs';
import { StorageService } from 'src/app/core/interceptor/storage.service';
import { AllinoneService } from 'src/app/core/services/allinone.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  fieldTextType: boolean = false;
  socialUser!: SocialUser;
  isLoggedin?: boolean = false;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private elementRef: ElementRef,
    private ngxLoader: NgxUiLoaderService,
    private auth: AuthService,
    private storage: StorageService,
    private route: Router,
    private toastr: ToastrService,
    private allsrv: AllinoneService,
    protected authService2: SocialAuthService
  ) {}

  loginform = new FormGroup({
    email: new FormControl('', [
      Validators.pattern(
        '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@' +
          '[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'
      ),
      Validators.required,
    ]),
    password: new FormControl('', [Validators.required]),
  });

  get loginControl() {
    return this.loginform.controls;
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  ngOnInit(): void {
    sessionStorage.clear();
    this.isLoggedin = false;
    this.storage.variable(false);
    this.jqureymethods();
    this.getGoogleSetup();
    if(this.storage.getemail() != null || this.storage.getemail() !=undefined){
      this.updateLogin(this.storage.getemail())
    }
  }

  getGoogleSetup() {
    this.authService2?.authState?.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (user) => {
            this.socialUser = user;
            this.isLoggedin = user != null;
            if (this.isLoggedin == true) {
              const loginData = {
                email: this.socialUser.email,
                password: '',
                socialMedia: true,
                deviceDetails: {
                  fcmToken: '',
                  deviceModel: 'Web',
                },
              };
              this.getLogin(loginData, environment.OuthToken);
            }
      },
      error: (error) => {
        this.ngxLoader.stop();
        this.toastr.error(error.error.message);
      },
    });
  }

  updateLogin(data:any){
      if(data.socialMedia == false){
        this.loginform.setValue({
          email : data.email,
          password : data.password,
        })
        this.loginWithToken();
      }
      else if(data.socialMedia == true){
        const loginData = {
          email: data.email,
          password: '',
          socialMedia: true,
          deviceDetails: {
            fcmToken: '',
            deviceModel: 'Web',
          },
        }
        this.getLogin(loginData ,environment.OuthToken)
      }
  }

  getLogin(loginData: any, token: any) {
   // //console.log(this.isLoggedin);
    this.auth.userGoogle(loginData, token).subscribe({
      next: (data) => {
        this.storage.setusername(data.payload);
        this.storage.setRoles(data.payload.roles[0]);
        this.storage.setToken(data.payload.uuid);
        this.storage.variable(true);
        this.allsrv.setdynamicmenu();
        this.allsrv.setRoles();
        this.allsrv.setToken();
        this.allsrv.setUser();
        this.ngxLoader.stop();
        let role = data?.payload?.roles[0]; // Assuming data is your object and roles is an array
        this.storage.setuseremail(loginData);
        let lowercaseRole = role?.toLowerCase();
        if (lowercaseRole == 'admin') {
          this.route.navigate(['/admin/realtime']);
        } else {
          this.route.navigate(['/Jobs']);
        }
      },
      error: (error) => {
        if(error.error.message == "Unauthorized user"){
          this.toastr.error(`Please Register or check your credentials properly,&emsp; We didn\'t find any account`, '' , {
            enableHtml: true,
            closeButton: false,
            timeOut: 10000
        });
          this.route.navigate(['/register']);
        }
        else if(error?.error?.error == 'Internal Server Error'){
          this.toastr.error(`Internal Server Error,&emsp; Please Free to Contact support@wanteddrivers.in`, '' , {
            enableHtml: true,
            closeButton: false,
            timeOut: 10000
        });
         }
         else{
          this.toastr.error(error.error.message);
         }
      },
    });
  }

  jqureymethods() {
    var s2 = document.createElement('script');
    s2.type = 'text/javascript';
    s2.src = 'assets/js/theme2.js';
    this.elementRef.nativeElement.appendChild(s2);
  }

  async loginWithToken() {
    if (!this.loginform.valid) {
      Object.keys(this.loginform.controls).forEach((field) => {
        const control: any = this.loginform.get(field);
        control.markAsTouched({ onlySelf: true });
      });
    } else if (this.loginform.valid) {
      this.ngxLoader.start();
      const loginData = {
        email: this.loginform.value.email,
        password: this.loginform.value.password,
        socialMedia: false,
        deviceDetails: {
          fcmToken: '',
          deviceModel: 'Web',
        },
      };
      // service call of login api
      this.auth.useremaillogin(loginData).subscribe({
        next: (data) => {
         // //console.log(data);
          this.storage.setuseremail(null);
          this.storage.setusername(data.payload);
          this.storage.setRoles(data.payload.roles[0]);
          this.storage.setToken(data.payload.uuid);
          this.storage.variable(true);
          this.allsrv.setdynamicmenu();
          this.allsrv.setRoles();
          this.allsrv.setToken();
          this.allsrv.setUser();
          this.ngxLoader.stop();
          this.storage.setuseremail(loginData);
         // //console.log(data?.payload?.roles[0])
          let role = data.payload.roles[0]; // Assuming data is your object and roles is an array
          let lowercaseRole = role.toLowerCase();
          if (lowercaseRole == 'admin') {
            this.route.navigate(['/admin/realtime']);
          } else {
            this.route.navigate(['/Jobs']);
          }
        },
        error: (error) => {
          this.ngxLoader.stop();
          if (error?.error?.message === "Unauthorized user") {
            this.toastr.error(
              `Please Register or check your credentials properly,&emsp; We didn\'t find any account`,
              '',
              { enableHtml: true, timeOut: 10000 }
            );
            this.route.navigate(['/register']);
          }
          else if (error?.error?.error === 'Internal Server Error') {
            this.toastr.error(
              `Internal Server Error,&emsp; Please Free to Contact support@wanteddrivers.in`,
              '',
              { enableHtml: true, timeOut: 10000 }
            );
          }
          else {
            this.toastr.error(error?.error?.message || 'Something went wrong');
          }

      }
      });
    }
  }

  signInWithFB(): void {
    this.authService2.signIn(FacebookLoginProvider.PROVIDER_ID);
  }

  signOut(): void {
    this.authService2.signOut();
    return;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
